<template>
	<div class="u-stack-md">
		<CloLoadingAnimation v-if="loading" class="LoadingAnimation--basic" />
			<CloResultsGallery
				v-if="list.length"
				:list="list"
				dataFormat="search2.0"
				mediaVersion="2.0"
				integratedLightbox
				ratingEnabled
				:getRatingsUrl="getRatingsUrl"
				:saveRatingUrl="saveRatingUrl"
				:ratingCsrf="ratingCsrf"
				:mediaDownloadUrl="mediaDownloadUrl"
				caption="checklist"
				:responsiveImages="false"
			/>

		<div v-if="error" class="GridFlex GridFlex--alignMiddle GridFlex--alignCenter u-inset-md">
			<div class="u-textCenter">
				<p class="u-text-3 u-margin-none">{{ $t('hsinfo.mediaUnavailable') }}</p>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import CloLoadingAnimation from '@/base/CloLoadingAnimation/CloLoadingAnimation';
import CloResultsGallery from '@/media/CloResultsGallery/CloResultsGallery';

export default {
	components: {
		CloLoadingAnimation,
		CloResultsGallery,
	},
	data() {
		return {
			list: [],
			loading: false,
			error: false,
		};
	},
	props: {
		obsId: {
			type: String,
			required: true,
		},
		getRatingsUrl: {
			type: String,
			required: true,
		},
		saveRatingUrl: {
			type: String,
			required: true,
		},
		ratingCsrf: {
			type: String,
			required: true,
		},
		mediaDownloadUrl: {
			type: String,
			required: true,
		},
		mediaApi: {
			type: String,
			required: true
		},
		searchUrl: {
			type: String,
			required: true,
		},
		mlUrl: {
			type: String,
			required: true,
		},
		baseUrl: {
			type: String,
			required: true,
		},
		sppLocale: {
			type: String,
			required: true,
		},
		portalRoot: {
			type: String,
			required: true
		}
	},
	mounted() {
		this.getMedia();
	},
	methods: {
		getMedia() {
			this.loading = false;
			axios.get(this.baseUrl + 'obsservice/media?obsId=' + this.obsId)
				.then((res) => {
					const mediaList = res.data
					if (mediaList.length) {
						this.getMediaData(mediaList)
					}
				})
				.catch((err) => {
					//console.log(err);
					this.error = true;
					
				});
		},
		getMediaData(mediaList) {
			const assetIds = mediaList.map((asset) => {
				return asset.assetId
			}).join(',')
			axios.get(this.mediaApi + 'search?unconfirmed=incl&sort=id_asc&assetId=' + assetIds)
				.then((res) => {
					this.list = res.data
					this.loading = false
					// need to remove data-asset-id attributes to not conflict with Lichen 1
					let count = 0;
					let timer = setInterval(() => {
						this.fixLichen();
						count++;
						if (count > 10) {
							clearInterval(timer);
						}
					}, 500);
				})
				.catch((err) => {
					//console.log(err);
					this.error = true;
					
				});
		},
		fixLichen() {
			const els = this.$el.querySelectorAll('[data-asset-id]');
			Array.prototype.forEach.call(els, (el) => {
				el.removeAttribute('data-asset-id');
			});
		},
	},
};
</script>

<style lang="scss">
// need to fix CSS for Lichen 1 and 2 conflicts
.Lightbox--dark {
	background-color: darken($color-black, 5%);
	.Button--close {
		background-color: $color-neutral-6;
	}
	.Lightbox-navigation {
		.Lightbox-previous,
		.Lightbox-next {
			background-color: $color-neutral-6;
		}
	}
	.Lightbox-caption {
		border: 0;
	}
}
.Lightbox-meta {
	background-color: transparent;
	border: 0;
}
.RatingStars .Icon--star {
	margin: 0;
}
// Target new lightbox to override a Lichen 1 style creeping in
.Lightbox--reverse {
	.Lightbox-carousel {
		position: static; // override Lichen 1 position absolute
	}
}

.SpectrogramPlayer .SpectrogramPlayer-frame {
	height: unset;
}
.Tooltip {
	display: block;
	height: 2rem;
}
.Button--secondary {
	background-color: $color-neutral-2;
	&:hover {
		background-color: darken($color-neutral-2, 5%);
		color: $color-neutral-6;
	}
}
</style>
